module.exports = __webpack_public_path__ + "static/Reporting-f5466a6e29679ab06875b509e3905608.png";